import { render } from "./email-opt-in-wrapper.vue?vue&type=template&id=5fdc67dd"
import script from "./email-opt-in-wrapper.vue?vue&type=script&lang=js"
export * from "./email-opt-in-wrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__